module.exports = __webpack_public_path__ + "img/ico-warning.4b021214.svg";